import clsx from 'clsx';
import { DayPicker, type DateRange } from '@daypicker/react';
import { es } from '@daypicker/react/locale';
import { OptionIcon } from '../option-icon/option-icon.component';
import { OutlineButton } from '../outline-button/outline-button.component';
import { style } from './date-range-picker.module.css';

export interface DateRangeOption {
  title: string;
  from: Date;
  to: Date;
}

interface Props {
  value?: DateRange;
  month?: Date;
  options?: DateRangeOption[];
  onChange: (value: DateRange) => void;
  onMonthChange: (month: Date) => void;
  onApply: () => void;
}

export function DateRangePicker(props: Props) {

  const {
    value,
    month,
    options,
    onChange,
    onMonthChange,
    onApply
  } = props;

  function handleOptionClick(option: DateRangeOption) {
    onChange(option);
    onMonthChange(option.to);
  }

  function isOptionSelected(option: DateRangeOption) {
    return (
      option.from.toLocaleDateString() === value?.from?.toLocaleDateString() &&
      option.to.toLocaleDateString() === value?.to?.toLocaleDateString()
    );
  }

  return (
    <>
      <div 
        className={style.dateRangeContainer} 
        onClick={e => e.stopPropagation()}>
        <div className={style.options}>
          {options?.map(option => 
            <div 
              key={option.title}
              className={clsx(style.option, isOptionSelected(option) && style.optionSelected)}
              onClick={() => handleOptionClick(option)}>
              {option.title}
            </div>
          )}
        </div>
        <div className={style.dateRange}>
          <DayPicker 
            mode='range'
            required={true}
            navLayout='around'
            pagedNavigation={true}
            captionLayout='dropdown-years'
            locale={es}
            numberOfMonths={2}
            selected={value}
            startMonth={new Date(2022, 0)}
            month={month}
            onMonthChange={onMonthChange}
            fixedWeeks={true}
            reverseYears={true}
            onSelect={onChange}
            components={{
              PreviousMonthButton: (props) => (
                <button {...props}>
                  <OptionIcon
                    className={style.navButton}
                    disabled={props['aria-disabled'] == true}
                    icon='chevron_left'/>
                </button>
              ),
              NextMonthButton: (props) => (
                <button {...props}>
                  <OptionIcon
                    className={style.navButton}
                    disabled={props['aria-disabled'] == true}
                    icon='chevron_right'/>
                </button>
              )
            }}/>
        </div>
      </div>
      <div 
        className={style.dateRangeFooter}
        onClick={e => e.stopPropagation()}>
        <OutlineButton
          style={style.button} 
          text='Aplicar'
          onClick={onApply}/>
      </div>
    </>
  );
}
